// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__DS0VA","boxTitle":"Qualiphy_boxTitle__3qkk-","box":"Qualiphy_box__36z1p","toggleWrap":"Qualiphy_toggleWrap__2pDZc"};